// extracted by mini-css-extract-plugin
module.exports = {"BackButton":"BackButton_BackButton__Ckse4","container":"BackButton_container__1PBwt"};